module.exports = __webpack_public_path__ + "static/Pacifico-Regular-9b94499ccea3bd82b24cb210733c4b5e.ttf";